module.exports = __webpack_public_path__ + "img/_54A6715.25208f4a.jpg";